let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("bDo1N")).then(() => parcelRequire('2RVA3'));